// JS calculo de cantidades para envio gratis

$(document).ready(function(){
    // variantes
    let total

    // acciones
    sendPrice()
    sendPricePrint()

    $('body').on('click', '.js-send-price__action', function(event) {
        sendPrice()
        sendPricePrint()
    })

    $('body').on('change', '.js-send-price__action-input', function(event) {
        sendPrice()
        sendPricePrint()
    })

    // funciones
    function sendPrice() {
        $.ajax({
            type: 'GET',
            url: '/cart',
            dataType: 'html',
            async: false,
            success: res => {
                total = $(res).find('.js-send-price__total').data('send-price__total')
            }
        })
    }

    function sendPricePrint() {
        const formatter = new Intl.NumberFormat('en-US', {
            currency: 'USD',
            minimumFractionDigits: 2
        })

        $('.js-send-price__content').each( function (){
            if ( ($(this).data('send-price__send') - Math.ceil(total)) > 0 ) {
                $(this).html(`Agrega $ ${formatter.format( ($(this).data('send-price__send') - Math.ceil(total))/100) } para envío gratis`)
            }else{
                $(this).html(`Tu envío es gratis`)
            }
        })
    }

})
